import { useSelector } from "react-redux";
import { productCardCustomizations } from "src/data/staticData";
import useScrollOnMount from "src/hooks/App/useScrollOnMount";
import ProductCard from "../../shared/productcard/ProductCard/ProductCard";
import s from "./WishProducts.module.scss";

const WishProducts = () => {
  const { wishList } = useSelector((state) => state.products);
  useScrollOnMount(160);

  return (
    <div className={s.wishProducts}>
      {wishList?.length>0? wishList.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
          customization={productCardCustomizations.wishListProducts}
          removeFrom="wishList"
        />
      )) :<h2>Wish list Product Not Available</h2>}
    </div>
  );
};
export default WishProducts;
